import React from 'react'
import PropTypes from 'prop-types'
import { Form, Alert } from 'react-bootstrap'
import { FaCopy } from 'react-icons/fa'

import { cl } from '../../../utilities/cl'

class TextCopy extends React.Component {
    constructor(props) {
        super(props)
        this.textareaRef = React.createRef()
        this.state = {
            showAlert: false,
            value: this.props.value || ""
        }
        this.hCopy = this.hCopy.bind(this)
        this.hChange = this.hChange.bind(this)
        this.adjustHeight = this.adjustHeight.bind(this)
    }

    componentDidMount() {
        // Автовысота при первом появлении
        if (this.props.editable) {
            this.adjustHeight()
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value || "" }, () => {
                // Автовысота после обновления значения
                if (this.props.editable) {
                    this.adjustHeight()
                }
            })
        }
    }

    adjustHeight() {
        const textarea = this.textareaRef.current
        if (textarea) {
            // Сбрасываем высоту для корректного вычисления scrollHeight
            textarea.style.height = 'auto'
            // Устанавливаем высоту по содержимому
            textarea.style.height = textarea.scrollHeight + 'px'
        }
    }

    hCopy() {
        const valueToCopy = this.state.value
        navigator.clipboard.writeText(valueToCopy)
        this.setState({ showAlert: true })
        setTimeout(() => {
            this.setState({ showAlert: false })
        }, 2000)
    }

    hChange(event) {
        const value = event.target.value
        this.setState({ value }, () => {
            // Автовысота при вводе текста
            this.adjustHeight()
            
            if (typeof this.props.onChange === "function") {
                this.props.onChange({
                    name: this.props.name,
                    value: value
                })
            }
        })
    }

    render() {
        let {
            className = "",
            label,
            name,
            comment,
            disabled,
            hidden,
            editable,
            style = {},
            placeholder,
        } = this.props

        const { value } = this.state
        const hasValue = value !== undefined && value !== null && value !== ""

        className = cl(className, { hidden: hidden }, "FormTextCopy")

        return (
            <div className={className} name={name} {...style}>
                {this.state.showAlert && (
                    <Alert variant="info" className="FormTextCopy__alert">
                        Скопировано в буфер обмена
                    </Alert>
                )}
                <Form.Group>
                    {label && <Form.Label>{label}</Form.Label>}
                    {editable ? (
                        <div
                            className={`FormTextCopy__container ${disabled ? "disabled" : ""}`}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-end',
                                backgroundColor: 'transparent',
                                borderColor: "rgba(10, 10, 10, 0.48)",
                                borderWidth: 0,
                                borderBottomWidth: 1,
                                borderStyle: 'solid',
                                borderRadius: 0,
                                padding: '0.375rem 0.75rem',
                                paddingLeft: 0
                            }}
                        >
                            <Form.Control
                                ref={this.textareaRef}
                                as='textarea'
                                value={value}
                                onChange={this.hChange}
                                disabled={disabled}
                                placeholder={placeholder}
                                rows={1}
                                style={{
                                    // Скрываем полосу прокрутки
                                    scrollbarWidth: 'none',
                                    msOverflowStyle: 'none',
                                    '&::-webkit-scrollbar': {
                                        display: 'none'
                                    },
                                    // Автовысота
                                    resize: 'none',
                                    overflow: 'hidden',
                                    minHeight: '38px',
                                    height: 'auto',
                                    // Остальные стили
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    padding: 0,
                                    flex: 1,
                                }}
                            />
                            {hasValue && !disabled && (
                                <FaCopy
                                    className="FormTextCopy__icon"
                                    style={{ 
                                        cursor: 'pointer',
                                        marginLeft: '8px',
                                        marginBottom: '10px'
                                    }}
                                    onClick={this.hCopy}
                                />
                            )}
                        </div>
                    ) : (
                        <div
                            className={`FormTextCopy__container form-control ${disabled ? "disabled" : ""}`}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-end'
                            }}
                            onClick={() => !disabled && hasValue && this.hCopy()}
                        >
                            <span className="FormTextCopy__value">
                                {hasValue ? value : "пусто"}
                            </span>
                            {hasValue && !disabled && (
                                <FaCopy
                                    className="FormTextCopy__icon"
                                    style={{ cursor: 'pointer' }}
                                />
                            )}
                        </div>
                    )}
                    {comment && <div className="FormTextCopy__comment">{comment}</div>}
                </Form.Group>
            </div>
        )
    }
}

TextCopy.propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    comment: PropTypes.string,
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    editable: PropTypes.bool,
    style: PropTypes.object,
    onChange: PropTypes.func,
}

export default TextCopy